<nz-select
nzShowSearch
nzAllowClear
[nzDropdownStyle]="{ 'max-height': '300px' }"
nzPlaceHolder="请选择"
[nzMode]="mode"
(ngModelChange)="modelChange($event)"
[(ngModel)]="defaultValue"
[nzDropdownRender]="renderTemplate"
[nzShowSearch]="showSearch"
>
    <nz-option *ngFor="let item of dataSource" nzAllowClear [nzLabel]="item.Name"
        [nzValue]="item.Id">
    </nz-option>
</nz-select>
<ng-template #renderTemplate>
    <nz-spin *ngIf="isLoading"></nz-spin>
  </ng-template>
